import { getIdToken } from "@/services/Auth";
import { getBaseApiUrl, getDefaultHeaders, request } from "@/utils/CreativeIntelligenceApi";
import { API_ROUTES } from "@/constants";

export async function getSataliaDomains() {
    const baseUrl = getBaseApiUrl();

    const url = `${baseUrl}${API_ROUTES.SATALIA_DOMAINS}`;
    const token = await getIdToken();
    const headers = getDefaultHeaders(token);

    return request<string[]>(url, headers);
}
